export default __webpack_public_path__ + "assets/images/96c196135ab97a2ebb20ede5bcf08a80.svg";